<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card class="card card-new-password" max-width="400">
      <v-form @submit.prevent="handleChangeNewPassword" ref="form" lazy-validation v-model="valid">
        <v-img class="white--text" height="100px" src="static/bg-slidebar.png" gradient="to top right, rgba(100,115,201,.5), rgba(25,32,72,.7)">
          <v-card-title class="card-new-password--text">Alteração de Senha</v-card-title>
        </v-img>

        <v-card-text>
          <v-text-field
            prepend-icon="lock"
            :append-icon="showPasswoard ? 'visibility_off' : 'visibility'"
            :type="showPasswoard ? 'text' : 'password'"
            name="newPassword"
            label="Senha"
            v-model="newPassword"
            @click:append="showPasswoard = !showPasswoard"
            @input="changePasswordValue"
            required
            :rules="newPasswordRules"
          ></v-text-field>

          <v-text-field
            prepend-icon="lock"
            :append-icon="showNewPasswoard ? 'visibility_off' : 'visibility'"
            :type="showNewPasswoard ? 'text' : 'password'"
            name="newPasswordConfirmation"
            label="Confirmar Senha"
            v-model="newPasswordConfirmation"
            @click:append="showNewPasswoard = !showNewPasswoard"
            @input="validatePasswordConfirmation"
            required
            :rules="newPasswordConfirmationRules"
          ></v-text-field>
        </v-card-text>

        <i4proValidatePassword v-if="dialog" id="forceValidation" :stringValue="newPassword" @validatePassword="validatePassword" />

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleClearForm"> <v-icon>far fa-times-circle</v-icon>Cancelar </v-btn>

          <v-btn type="submit" color="primary" :disabled="!valid || !isValidPassword"> <v-icon>far fa-save</v-icon>Salvar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { sleep } from '@/helpers/page';

export default {
  components: {
    i4proValidatePassword: () => import('@/components/validators/i4pro-validate-password')
  },

  data() {
    return {
      valid: true,
      showPasswoard: false,
      showNewPasswoard: false,
      isValidPassword: false,
      dialog: true,
      newPassword: '',
      newPasswordConfirmation: '',
      newPasswordRules: [v => !!v || 'Campo obrigatório'],
      newPasswordConfirmationRules: [v => !!v || 'Campo obrigatório', v => v !== this.newPassword && 'Senhas precisam ser idênticas']
    };
  },

  methods: {
    changePasswordValue(value) {
      this.newPassword = value;
    },

    validatePassword(param) {
      this.isValidPassword = param;

      this.validatePasswordConfirmation();
    },

    validatePasswordConfirmation() {
      this.newPassword !== this.newPasswordConfirmation || this.isValidPassword === false ? (this.valid = false) : (this.valid = true);
    },

    async handleChangeNewPassword() {
      const { newPassword, newPasswordConfirmation } = this;

      await this.$store.dispatch('authentication/editPassword', { newPassword, newPasswordConfirmation });

      this.handleClearForm();
    },

    async handleClearForm() {
      this.$refs.form.reset();
      this.$emit('handleAccount');

      let forceValidation = document.getElementById('forceValidation');
      forceValidation.style.display = 'none';
      await sleep(600);
      forceValidation.style.display = 'block';
    }
  }
};
</script>

<style lang="scss" scoped>
button {
  .v-btn__content {
    .v-icon {
      margin-right: 10px;
      font-size: 20px;
    }
  }
}
</style>
